class ImmersiveCollections extends HTMLElement {
  connectedCallback() {
    if (this.isConnectedReady) return;

    this.isConnectedReady = true;
    this.cards = Array.from(this.querySelectorAll('[data-immersive-card]'));
    this.mediaQuery = window.matchMedia('(max-width: 989px)');
    this.handleModeChange = this.handleModeChange.bind(this);

    this.cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (!this.mediaQuery.matches) return;
        if (event.target.closest('a')) return;
        this.setActiveCard(card);
      });
    });

    this.mediaQuery.addEventListener('change', this.handleModeChange);
  }

  disconnectedCallback() {
    this.mediaQuery?.removeEventListener('change', this.handleModeChange);
  }

  setActiveCard(selectedCard) {
    const shouldOpen = !selectedCard.classList.contains('is-active');

    this.cards.forEach((card) => {
      const isActive = card === selectedCard && shouldOpen;
      card.classList.toggle('is-active', isActive);
      card.querySelector('[data-immersive-toggle]')?.setAttribute('aria-expanded', String(isActive));
    });
  }

  handleModeChange(event) {
    if (event.matches) return;

    this.cards.forEach((card) => {
      card.classList.remove('is-active');
      card.querySelector('[data-immersive-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('immersive-collections')) {
  customElements.define('immersive-collections', ImmersiveCollections);
}
